module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/gold_left_2.0eabde1b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/gold_left_2.png
// module id = 2860
// module chunks = 11